<template>
    <div class="col-md-12 panel">
                <loading :active.sync="isLoading" color="#4c4a49" :is-full-page="false"></loading>
                <div class="row">
                    <div class="col-md-12">
                        <div class="panel">
                            <div class="panel-heading">
                                <div class="panel-title hidden-xs">
                                    <span class="glyphicon glyphicon-tasks"></span>Средняя продолжительность времени между первой и последней покупкой клиента <span
                                        id="instructor_name"></span></div>
                            </div>
                            <form v-on:submit.prevent="getReport" class="ng-pristine ng-valid">
                                <div class="panel-body ">
                                    <div class="col-md-4">
                                        <input type="date" v-model="filter.from" class="form-control"
                                               value="" placeholder="Начало периода" required="">
                                    </div>
                                    <div class="col-md-4">
                                        <input type="date" v-model="filter.to" class="form-control"
                                               value="" placeholder="Конец периода" required="">
                                    </div>

                                </div>
                                <div class="panel-footer">
                                    <button type="submit" class="btn btn-primary getstat"> Показать </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div class="section row" v-if="rows.length > 0">
                    <div class="col-md-12">
                        <div class="panel panel-visible">

                            <div class="panel-body pn">
                                <table class="table table-striped table-hover datatables table-fixed-header" cellspacing="0" width="100%">
                                    <thead>
                                    <tr>
                                        <th>Клиент</th>
                                        <th colspan="2"><abbr title="В заданной периоде">Первая покупка</abbr></th>
                                        <th colspan="2"><abbr title="В заданной периоде">Последняя покупка</abbr></th>
                                        <th>Продолжительность</th>
                                        <th>Средний чек</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(row, index) in rows" v-bind:key="index">
                                        <td>
                                          <router-link :to="{name: 'clients-edit', params: {id: row.client_id}}">{{row.client}}</router-link>
                                        </td>
                                        <td>
                                          {{row.first.date}}
                                        </td>
                                        <td class="sum-cell">
                                          <span class="badge badge-info">{{row.first.sum | numberFormat()}}</span>
                                        </td>
                                        <td>
                                          {{row.last.date}}
                                        </td>
                                        <td class="sum-cell">
                                          <span class="badge badge-info">{{row.last.sum | numberFormat()}}</span>
                                        </td>
                                        <td class="sum-cell">{{ durationFormat(row.duration) }}</td>
                                        <td class="sum-cell">{{row.average_sale | numberFormat()}}</td>
                                    </tr>
                                    </tbody>
                                    <tfoot>
                                    <tr v-if="rows.length > 0">
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td class="sum-cell">{{durationFormat(total.duration)}}</td>
                                        <td class="sum-cell">{{total.average | numberFormat(2)}}</td>
                                    </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

    </div>
</template>

<script>
    import Report from "../../classes/api/Report";
    import moment from 'moment';
    import Helper from '../../classes/Helper'

    export default {
        components: {
            Loading: () => import('vue-loading-overlay'),
        },
        mounted() {
            this.getReport();
        },
        computed: {
            total: function() {
                let total = {
                    duration: 0,
                    average: 0,
                };
                for (let row of this.rows) {
                  total.duration += row.duration
                  total.average += row.average_sale
                }
                total.duration /= this.rows.length
                total.average /= this.rows.length
                return total;
            },
        },
        data() {
            return {
                isLoading: false,
                filter: {
                    from: moment().format('YYYY-MM-01'),
                    to: moment().format('YYYY-MM-DD'),
                },
                rows: [],
            };
        },
        methods: {
            async getReport() {
                this.isLoading = true;
                let response = await Report.getAverageDurationBetweenSale(this.filter.from, this.filter.to);
                this.rows = response.data;
                this.isLoading = false;
            },
            durationFormat(value) {
              let days = Math.floor(value / 86400)
              let hours = Math.floor((value - (days * 86400)) / 3600);
              let minutes = Math.floor((value - (hours * 3600) - (days * 86400)) / 60);
              let seconds = Math.floor(value - ((hours * 3600) + (minutes * 60) + (days * 86400)));
              if (seconds > 30) {
                minutes++;
              }
              if (minutes > 30) {
                hours++
              }
              if (hours > 12) {
                days++
              }
              let result = '';
              if (days > 0) {
                result += `${days} ${Helper.pluralForm(days, ['день', 'дня', 'дней'])} `
              } else {
                result += 'Меньше дня'
              }

              return result;
            },
        },
        metaInfo() {
            return {
                title: 'Отчеты - Средняя продолжительность времени между первой и последней покупкой клиента',
                meta: [
                    {vmid: 'description', name: 'description', content: ''},
                    {vmid: 'keywords', name: 'keywords', content: ''},
                ],
            };
        },
    }
</script>
